module.exports = __webpack_public_path__ + "img/ic_calls.d546324.svg";